import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[notStartNationalIdOne]'
})
export class NotStartNationalIdOneDirective {

  constructor(private ngControl: NgControl, private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const currentValue: string = this.ngControl.value || '';
    const keyPressed: string = event.key;

    // Allow backspace and delete
    if (keyPressed === 'Backspace' || keyPressed === 'Delete') {
      return;
    }

    // Prevent starting with '1'
    if (currentValue === '' && keyPressed === '1') {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (value.startsWith('1')) {
      // Remove the leading '1'
      const newValue = value.replace(/^1+/, '');
      this.ngControl.control?.setValue(newValue);
    }
  }
}
